// extracted by mini-css-extract-plugin
module.exports = {"border":"AssetFormItem_border__raYqv","header":"AssetFormItem_header__jOIQw","error":"AssetFormItem_error__2Qomy","input":"AssetFormItem_input__1lCn7"};